import React from "react";
import { Col, Row } from "@insightfulscience/atomic-react/Grid";
import { useLocale } from "@insightfulscience/i18";
import SmartForm from "@insightfulscience/smart-react/SmartForm";
import Button from "@insightfulscience/atomic-react/Button";
import useTracking, { CATCH } from "@insightfulscience/smart-react/useTracking";
import Spinner from "@insightfulscience/atomic-react/Spinner";
import Block from "@insightfulscience/atomic-react/Block";
import { initialState, validateForm } from "./form";
import useResultStatus from "../utils/useResultStatus";
import actionForm from "./action";

const ViewerForm = () => {
	const [t] = useLocale("snapgene-viewer");

	const [requestAction, isRequestProcessing] = useTracking(actionForm, CATCH);
	const [action, { errors }, resetResult] = useResultStatus(requestAction);

	return (
		<>
			{isRequestProcessing && <Spinner />}
			<SmartForm
				textRender={t}
				{...{ initialState, validateForm, action }}
				onTouched={resetResult}
			>
				<SmartForm.Field
					label="EMAIL"
					name="email"
					type="email"
					disabled={isRequestProcessing}
					error={errors.message}
					fieldClassName="mb-8"
					required
				/>
				<Row>
					<Col spacing={{ mt: 4, mb: 2 }}>
						<Block sx={{ textAlign: "center" }}>
							<Button type="submit" disabled={isRequestProcessing}>
								{t("SUBMIT")}
							</Button>
						</Block>
					</Col>
				</Row>
			</SmartForm>
		</>
	);
};

export default ViewerForm;
